import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as dashboardActions from './../../actions/dashboardActions';
import * as tradepanelActions from './../../actions/tradepanelActions';
import * as commonActions from './../../actions/commonActions';
import * as instrumentListActions from './../../actions/instrumentListActions';
import * as activityActions from './../../actions/activityActions';
import * as authActions from '../../redux/modules/auth';
import styles from './TradePanel.less';
import { ButtonToolbar, DropdownButton, MenuItem, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import TimeField from 'react-simple-timefield';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import Modal from 'react-modal';
import i18next from 'i18next';
import appConstants from './../../appConstants';
import track from 'react-tracking';
import { applyStyle, applyToHover, getDefaultAcdAccount, getSeparator, setDirection, unformatLang} from './../../utils/utils';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
import { displayInActiveAccMsg } from './../../utils/validation';

let separator;
let decimal;
let decimalCount = 0;
let wsData;

// const elementsData = [
//   {"classNames":"header","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"part1TabContent","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"part2TabContent","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"lmtSubmit","elementType":"normal", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"lmtClose","elementType":"normal", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"lmtRateDiff","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"closeBtn","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"sellBg","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"buyBg","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"cmdtyType","elementType":"normal", "applyTo":"all", "tagNames":"p"},
//   {"classNames":"trdDropDown","elementType":"tag", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"trdDropdownInput","elementType":"normal", "applyTo":"all", "tagNames":"input"},
//   {"classNames":"trdComments","elementType":"normal", "applyTo":"all", "tagNames":"textarea"},
//   {"classNames":"lmtModal","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"span"},
//   {"classNames":"dropDownList","elementType":"normal", "applyTo":"all", "tagNames":"li"},
//   {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
//   {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"}
// ];
const directionData=[
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"closeIconLmt","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"msgTitle","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"cmdtyType","elementType":"normal", "applyTo":"all", "tagNames":"p"},
  {"classNames":"col3","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"col4","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdMeasureDrpDown","elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"rightPart","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdDropdownInput","elementType":"normal", "applyTo":"all", "tagNames":"input"},
  {"classNames":"btnText","elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"commentDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"submitBtn","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"noRatesMsgDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
];
let index1 = 0;
let cmdtyId;
let COM;
@connect(state => ({
  ACD: state.auth.ACD,
	userDetail:state.auth.userDetail,
  trdPanelData: state.dashboardRoot.instrumentListReducer.trdPanelData,
  socketData: state.dashboardRoot.instrumentListReducer.socketData,
  socketDataStatic:state.dashboardRoot.instrumentListReducer.socketDataStatic,
  check:state.dashboardRoot.instrumentListReducer.check,
  status: state.dashboardRoot.instrumentListReducer.status,
  //ordcnfrmsg:state.dashboardRoot.activityReducer.ordcnfrmsg,
  //cmdtyArr:state.dashboardRoot.instrumentListReducer.cmdtyArr,
  //closeLmtFlag:state.dashboardRoot.dashboardReducer.closeLmtFlag,
  TCO:state.dashboardRoot.instrumentListReducer.TCO,
  lmtKeyValue : state.dashboardRoot.dashboardReducer.lmtKeyValue,
  selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  stkWiseMarkup:state.dashboardRoot.instrumentListReducer.stkWiseMarkup,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
  language:state.dashboardRoot.commonReducer.language,
  stkWiseMarkupRandomNo:state.dashboardRoot.instrumentListReducer.stkWiseMarkupRandomNo,
  orderStatus:state.dashboardRoot.tradepanelReducer.orderStatus,
  //checkClickOnAddWidgetFlag:state.dashboardRoot.commonReducer.checkClickOnAddWidgetFlag,
  custInstStkData:state.dashboardRoot.instrumentListReducer.custInstStkData,
  instData: state.dashboardRoot.instrumentListReducer.instData
}), {
	...authActions,
  ...dashboardActions,
  ...tradepanelActions,
  ...commonActions,
  ...instrumentListActions,
  ...activityActions
})

@track((props, state) => ({}))

export default class LimitOrderComponent extends Component {
  static propTypes = {
    socketData: PropTypes.array,
    socketDataStatic:PropTypes.array,
    check:PropTypes.string,
    trdPanelData: PropTypes.object,
    handleSellBuyLMTOrder:PropTypes.func,
    validateOrder:PropTypes.func,
    //ordcnfrmsg:PropTypes.object,
    closedLmtModal:PropTypes.func,
    //closeLmtFlag:PropTypes.bool,
    TCO: PropTypes.object,
		lmtKeyValue:PropTypes.string,
    stkWiseMarkup:PropTypes.object,
    stkWiseMarkupRandomNo:PropTypes.Number,
    custInstStkData:PropTypes.object
  }

  constructor() {
    super();
    window.handleLmtOrder = this.handleLmtOrder.bind(this);
    window.closeLmtOrdConfirmMsg = this.closeLmtOrdConfirmMsg.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.onTimeChange = this.onTimeChange.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    }
  state = {
    selectedRmk:"",
    convFactor:null,
    COM:null,
    cmdtyID:"",
    selectedCmdty: "",
    selectedQuantityLmt: "",
    selectedMeasureLmt: 'Type',
    DFLMT:[],
    MEASURE:[],
    Price: "",
    DealType: '',
    Validty: '',
    ValidtyKey: 0,
    showLmtDialog: false,
    time:moment().add(6, 'minute').format("hh:mm"),
    validationTime:(moment().add(6, 'minute').format("hh:mm")).substring(0, 2),
    timeFormat:moment().add(6, 'minute').format("A"),
    //actualTime:moment(moment().add(6, 'minute').format("hh:mm")+" PM", ["h:mm A"]).format("HH:mm"),///It was sending GTT in PM when by default selected hence changed it to AM initially load
    actualTime:moment(moment().add(6, 'minute').format("hh:mm") + " " + moment().add(6, 'minute').format("A"), ["h:mm A"]).format("HH:mm"),
    startDate: moment(),
    CTID: '',
    errorMsg:"",
    //isSubmitDisabled:false,
    cmdtyIndex:0,
    showtrdFlagModal:false,
    //showCnfrmMsg:false,
    TCO:[],
		OrderType:2,
		dealTypeKey:1,
    stkWiseAskMarkup:0,
    stkWiseBidMarkup:0,
    showPrice:'',
    orderSocketClosed:false,
    isCustInst:false,
    defaultAccountIsActive: false,
  }
  componentWillReceiveProps(nextProps){
    let index1;
    if(nextProps.cmdty !== this.props.cmdty){
      for (let index = 0; index < this.props.socketDataStatic.length; index++) {
        const cmdty = this.props.socketDataStatic[index].I;
        const cmdtyDes = this.props.socketDataStatic[index].ID;
        if (nextProps.cmdty === cmdty) {
           index1=index;
           break;
        }
      }
      this.setState({cmdtyIndex: index1});
      this.setState({COM:parseInt(this.props.socketDataStatic[index1].B)});
      this.setState({isCustInst:parseInt(this.props.socketDataStatic[index1].C) !== 32 ? false : true});
      const T1=this.props.socketDataStatic[index1].T1;
      this.setState({cmdtyID:this.props.socketDataStatic[index1].I});
      this.setState({selectedCmdty:nextProps.cmdty});
      this.setState({T1:T1});
      const DF=this.props.socketDataStatic[index1].DF;
      const DFParse=JSON.parse(DF);
      this.setState({DFLMT: DFParse});
      const unit = [];
      var tmpConvFactor=new Map();
      const lengthTrdData = this.props.trdPanelData.length;
      for (let index = 0; index < lengthTrdData; index++) {
        const stk_type = this.props.trdPanelData[index].stk_type;
        if (stk_type === T1) {
          unit.push(this.props.trdPanelData[index].C);
          tmpConvFactor.set(this.props.trdPanelData[index].C,this.props.trdPanelData[index].F)
        }
      }
      /// conversion factor for custom instrument
      if(this.props.custInstStkData !==undefined){
      for (let index = 0; index < this.props.custInstStkData.length; index++) {
        const stk_type = this.props.custInstStkData[index].S;
        if (stk_type === T1) {
          tmpConvFactor.set(this.props.custInstStkData[index].C, this.props.custInstStkData[index].F);
        }
      }
    }
      this.setState({convFactor:tmpConvFactor});
      this.setState({MEASURE:unit});
      this.setState({selectedMeasureLmt:unit[0]});
    }
    if(nextProps.stkWiseMarkupRandomNo !== this.props.stkWiseMarkupRandomNo){
      nextProps.instData.get(this.state.cmdtyID).C === 32 ? this.getStkWiseMarkup(this.state.cmdtyID, nextProps.instData.get(this.state.cmdtyID).BIID, nextProps.stkWiseMarkup)
      : this.getStkWiseMarkup(this.state.selectedMeasureMkt, this.state.cmdtyID, nextProps.stkWiseMarkup);
    }
    if(nextProps.userDetail.showPrice!==this.state.showPrice){
      if(nextProps.userDetail.showPrice!==undefined&&nextProps.userDetail.showPrice!=="undefined"){
        const showPrice = nextProps.userDetail.showPrice===undefined||nextProps.userDetail.showPrice==="undefined"?"BOTH":nextProps.userDetail.showPrice;
        var DealType=showPrice==="ASK"||showPrice==="BOTH"?'BUY':'SELL';
        var dealTypeKey = showPrice === "ASK" || showPrice === "BOTH"?1:0;
        this.setState({showPrice:showPrice,DealType: i18next.t(DealType),dealTypeKey:dealTypeKey});
      }
    }
  }
  componentWillMount() {
      const tco=JSON.parse(localStorage.getItem('TCO'));
      let checkComodity;
      if(this.props.cmdty){
        checkComodity=this.props.cmdty;
      }
      else {
          checkComodity=this.props.TCO[0].cmdtId;
      }
      this.setState({selectedCmdty:checkComodity});
  }
  componentDidMount(){
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName('closeBtn')[0], "classNames":"closeBtn"},
      {"elmToHover":thisComponent.getElementsByClassName("lmtSubmit")[0], "classNames":"lmtSubmit"},
      {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[0], "classNames":"lmtClose"}
    ];
   // //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    separator = getSeparator(navigator.language,'group');
    decimal = getSeparator(navigator.language,'decimal');
    const showPrice = this.props.userDetail.showPrice===undefined||this.props.userDetail.showPrice==="undefined"?"BOTH":this.props.userDetail.showPrice;
    var DealType=showPrice==="ASK"||showPrice==="BOTH"?'BUY':'SELL';
    var dealTypeKey = showPrice === "ASK" || showPrice === "BOTH"?1:0;
    this.setState({showPrice:showPrice,DealType: i18next.t(DealType),dealTypeKey:dealTypeKey});

    let checkComodity;
    if(this.props.cmdty){
      checkComodity=this.props.cmdty;
    }
    else {
        checkComodity=this.props.TCO[0].cmdtId;
    }
    this.setState({selectedCmdty:checkComodity});
    let index1;
    for (let index = 0; index < this.props.socketDataStatic.length; index++) {
      const cmdty = this.props.socketDataStatic[index].I;
      const cmdtyDes = this.props.socketDataStatic[index].ID;
      if (checkComodity === cmdty) {
         index1=index;
         break;
      }
    }
    this.setState({cmdtyIndex: index1});
    this.setState({COM:parseInt(this.props.socketDataStatic[index1].B)});
    this.setState({isCustInst:parseInt(this.props.socketDataStatic[index1].C) !== 32 ? false : true});
    COM = parseInt(this.props.socketDataStatic[index1].B);
    this.setState({cmdtyID:this.props.socketDataStatic[index1].I});
    const T1=this.props.socketDataStatic[index1].T1;
    this.setState({T1:T1});
    this.setState({Validty:this.props.userDetail.validityCodeForTrader[0].validityType,
    ValidtyKey:this.props.userDetail.validityCodeForTrader[0].validityType==="GTC"?"1":this.props.userDetail.validityCodeForTrader[0].validityType==="DAY"?"0":
      this.props.userDetail.validityCodeForTrader[0].validityType==="GTD"?"6":"60"});
    // const DF=this.props.socketDataStatic[index1].DF;
    // const DFParse=JSON.parse(DF);
    // this.setState({DFLMT: DFParse});
    const unit = [];
    var tmpConvFactor=new Map();
    const lengthTrdData = this.props.trdPanelData.length;
    for (let index = 0; index < lengthTrdData; index++) {
      const stk_type = this.props.trdPanelData[index].stk_type;
      if (stk_type === T1) {
        unit.push(this.props.trdPanelData[index].C);
        tmpConvFactor.set(this.props.trdPanelData[index].C,this.props.trdPanelData[index].F)
      }
    }
    /// conversion factor for custom instrument
    if(this.props.custInstStkData !==undefined){
    for (let index = 0; index < this.props.custInstStkData.length; index++) {
      const stk_type = this.props.custInstStkData[index].stk_type;
      if (stk_type === T1) {
        tmpConvFactor.set(this.props.custInstStkData[index].C, this.props.custInstStkData[index].F);
      }
    }
  }
    parseInt(this.props.socketDataStatic[index1].C) === 32 ? this.getStkWiseMarkup(this.props.socketDataStatic[index1].I, this.props.socketDataStatic[index1].BSID, this.props.stkWiseMarkup)
    : this.getStkWiseMarkup(unit[0], this.props.socketDataStatic[index1].I, this.props.stkWiseMarkup);
    this.setState({convFactor:tmpConvFactor});
    this.setState({MEASURE:unit});
    this.setState({selectedMeasureLmt:unit[0]});
    for (let index = 0; index < lengthTrdData; index++) {
      const stk_type = this.props.trdPanelData[index].stk_type;
      const type = this.props.trdPanelData[index].C;
      if (T1===stk_type && type===unit[0]) {
          const DF = this.props.trdPanelData[index].DF;
		      const conv_Factor = this.props.trdPanelData[index].F;
          const DFParse=JSON.parse(DF);
          this.setState({DFLMT:DFParse});
          this.setState({convFact:conv_Factor});
        }else if((this.props.socketDataStatic[index1].B===1&&this.props.socketDataStatic[index1].C===1)||
          (this.props.socketDataStatic[index1].B===1&&this.props.socketDataStatic[index1].C===2) || this.props.socketDataStatic[index1].C===32){
          const DF=this.props.socketDataStatic[index1].DF;
          const DFParse=JSON.parse(DF);
          this.setState({DFLMT: DFParse});
        }
    }
  }
  getStkWiseMarkup = (stk_code,cmdty,stkWiseMarkup) =>{
    try{
      if(stk_code!==undefined){
        if(stkWiseMarkup!==null){
          let stkCodeMarkup=stkWiseMarkup.get(cmdty);
          if(stkCodeMarkup !== undefined){
            for(let i=0;i<stkCodeMarkup.length;i++){
              if(stkCodeMarkup[i].SC===stk_code){
                this.setState({stkWiseAskMarkup: stkCodeMarkup[i].ASK,stkWiseBidMarkup: stkCodeMarkup[i].BID});
              }
            }
          }
        }
      }else{
        this.setState({stkWiseAskMarkup: 0,stkWiseBidMarkup: 0});
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'getStkWiseMarkup', component:"LimitOrderComponent"});
    }
  }
  quantitySelectionLmt = (event) => {
    try{
      if(event.target.text==="")
      {
        event.target.text="0"
      }
      var check= event.target.text.slice(event.target.text.length-1);
      var tempQ= event.target.text;
      if(check.toUpperCase()==='K')
      {
        tempQ= event.target.text.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000;
      }else if(check.toUpperCase()==='M'){
        tempQ= event.target.text.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000000;
      }
      let qty=(tempQ).toLocaleString(navigator.language,{minimumFractionDigits:3, maximumFractionDigits:3});
      qty=(qty).replace(getSeparator(navigator.language, 'group'), "");
      this.setState({selectedQuantityLmt: qty});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'quantitySelectionLmt', component:"LimitOrderComponent"});
    }
  }

  quantityTypedLmt = (event) => {
    try{
      var checkDecimal =getSeparator(navigator.language,'decimal');
      if(event.target.value.charAt(0)=== checkDecimal){
        event.target.value="0"+event.target.value;
      }
      var flag=0;
      var c=0;
      for(var i=0;i<event.target.value.length;i++){
        if(event.target.value.charAt(i)=== checkDecimal){
          flag=1;
        }
        if(flag==1){
          c++;
        }
      }
      if(c>4){
        event.target.value= this.state.selectedQuantityLmt;
      }
      if (!(event.target.value.charAt(0).toUpperCase()==='K' || event.target.value.charAt(0).toUpperCase()==='M')) {
      var check= event.target.value.slice(event.target.value.length-1);
      var tempQ= event.target.value;
      if(check.toUpperCase()==='K')
      {
        tempQ= event.target.value.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000;
      }else if(check.toUpperCase()==='M'){
        tempQ= event.target.value.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000000;
      }
        if(!isNaN(tempQ)){
        this.setState({selectedQuantityLmt: tempQ});
      }else{
        this.setState({selectedQuantityLmt: event.target.value});
      }
      }
      else{
        this.setState({selectedQuantityLmt: event.target.value});
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'quantityTypedLmt', component:"LimitOrderComponent"});
    }
  }

  selectMeasureLmt = (event) => {
    try{
      this.setState({selectedMeasureLmt: event.target.text});
      for (let index = 0; index < this.props.trdPanelData.length; index++) {
        const stk_type = this.props.trdPanelData[index].stk_type;
        const type = this.props.trdPanelData[index].C;
        if (this.state.T1===stk_type && type===event.target.text) {
            const DF = this.props.trdPanelData[index].DF;
            const DFParse=JSON.parse(DF);
            this.setState({DFLMT:DFParse});
        }
      }
      this.getStkWiseMarkup(event.target.text,this.state.cmdtyID,this.props.stkWiseMarkup);
      this.checkInputData(this.state.cmdtyID,this.state.Price,this.state.selectedQuantityLmt,event.target.text,this.state.OrderType,this.state.dealTypeKey,this.state.selectedRmk,this.state.ValidtyKey,this.state.time);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'selectMeasureLmt', component:"LimitOrderComponent"});
    }
  }
  onBlurLMT= (event)=> {
    try{
      var tempQ=event.target.value;
      if(tempQ===""){
        tempQ = "";
      }
      var checkDecimal =getSeparator(navigator.language,'decimal');
      if(event.target.value.charAt(0)=== checkDecimal){
        event.target.value="0"+event.target.value;
      }
      if (!(event.target.value.charAt(0).toUpperCase()==='K' || event.target.value.charAt(0).toUpperCase()==='M')) {
        var check= event.target.value.slice(event.target.value.length-1);
        tempQ= event.target.value;
        tempQ = unformatLang(tempQ);
          if(check.toUpperCase()==='K')
          {
            tempQ= event.target.value.slice(check, -1);
            tempQ=parseFloat(tempQ)*1000;
          }
          else if(check.toUpperCase()==='M')
          {
            tempQ= event.target.value.slice(check, -1);
            tempQ=parseFloat(tempQ)*1000000;
          }
          if(!isNaN(tempQ) && tempQ !=="" && tempQ !== 0)
          {

            tempQ= event.target.value;
            tempQ = unformatLang(tempQ);
            if(tempQ==="" || tempQ==="NaN" ){
              tempQ ="";
            }
            var tempQuant=Number(parseFloat(tempQ)).toLocaleString(navigator.language, {minimumFractionDigits:3, maximumFractionDigits:3});
            // var tempQuant=Number.isInteger(parseFloat(tempQ))?tempQ:Number(parseFloat(tempQ)).toLocaleString(navigator.language,{minimumFractionDigits:3,maximumFractionDigits:3});
            // tempQuant=(tempQuant).replace(getSeparator(navigator.language,'group'),"");
            this.setState({selectedQuantityLmt: tempQuant});
            // tempQuant=unformatLang(tempQuant);
            this.checkInputData(this.state.cmdtyID,this.state.Price,tempQuant,this.state.selectedMeasureLmt,this.state.OrderType,this.state.dealTypeKey,this.state.selectedRmk,this.state.ValidtyKey,this.state.time);
            tempQ=parseFloat(tempQ).toFixed(2);

        }
        else{
          if(event.target.value===""){
            tempQ = "";
          }
          this.setState({selectedQuantityLmt: tempQ});
          this.checkInputData(this.state.cmdtyID,this.state.Price,tempQ,this.state.selectedMeasureLmt,this.state.OrderType,this.state.dealTypeKey,this.state.selectedRmk,this.state.ValidtyKey,this.state.time);
        }
      }
      else{
        if(tempQ===""){
          tempQ = "";
        }
      	if(!isNaN(tempQ)){
          tempQ=Number.isInteger(parseFloat(tempQ))?tempQ: Number(parseFloat(tempQ)).toLocaleString(navigator.language,{minimumFractionDigits:3,maximumFractionDigits:3});
          this.setState({selectedQuantityLmt:tempQ});
          this.checkInputData(this.state.cmdtyID,this.state.Price,tempQ,this.state.selectedMeasureLmt,this.state.OrderType,this.state.dealTypeKey,this.state.selectedRmk,this.state.ValidtyKey,this.state.time);
        } else{
      	   this.setState({selectedQuantityLmt:tempQ});
           this.checkInputData(this.state.cmdtyID,this.state.Price,tempQ,this.state.selectedMeasureLmt,this.state.OrderType,this.state.dealTypeKey,this.state.selectedRmk,this.state.ValidtyKey,this.state.time);
      	}
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurLMT', component:"LimitOrderComponent"});
    }
  }

  selectValidty = (value) => {
    try{
      let validtyKey;
      this.setState({Validty: value});
      if(value==="GTC"){
        validtyKey="1";
        this.setState({ValidtyKey:validtyKey});
      }else if(value==="DAY"){
        validtyKey="0";
        this.setState({ValidtyKey:validtyKey});
      }else if(value==="GTD"){
        validtyKey="6";
        this.setState({ValidtyKey:validtyKey});
      }else if(value==="GTT"){
        validtyKey="60";
        this.setState({ValidtyKey:validtyKey,
        time:moment().add(6, 'minute').format("hh:mm"),
        validationTime:(moment().add(6, 'minute').format("hh:mm")).substring(0, 2),
        actualTime:moment(moment().add(6, 'minute').format("hh:mm")+" "+moment().add(6, 'minute').format("A"), ["h:mm A"]).format("HH:mm"),
        timeFormat:moment().add(6, 'minute').format("A")});
      }
    this.checkInputData(this.state.cmdtyID,this.state.Price,this.state.selectedQuantityLmt,this.state.selectedMeasureLmt,this.state.OrderType,this.state.dealTypeKey,this.state.selectedRmk,validtyKey,this.state.time);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'selectValidty', component:"LimitOrderComponent"});
    }
  }

  changePrice = (event) => {
    try{
      // if(event.target.value.indexOf(separator)!=-1 && separator !== ''){
      //   event.preventDefault();
      // }
      // else {
        this.setState({Price: event.target.value});
      // }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changePrice', component:"LimitOrderComponent"});
    }
  }

  checkNumberValue =(event) =>{
    try{
      if (String.fromCharCode(event.which) != separator && event.which > 31 && (event.which < 48 || event.which > 57) && (String.fromCharCode(event.which)!==separator) && (String.fromCharCode(event.which)!==decimal) && (event.which !== 107)  && (event.which !== 75) && (event.which !== 109) && (event.which !== 77)){
        event.preventDefault();
      }
      if(event.target.value.indexOf(decimal)===-1){
            decimalCount = 0;
      }
      // if(event.which === separator.charCodeAt(0) || (event.which === decimal.charCodeAt(0) && decimalCount>=1)){
      //     event.preventDefault();
      // }
      if(event.which === decimal.charCodeAt(0)){
        decimalCount+=1;
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'checkNumberValue', component:"LimitOrderComponent"});
    }
  }

  onBlurPrice = (event) =>{
    try{
      var price=event.target.value;
      price = unformatLang(price);
      var dec;
      for (let index = 0; index < this.props.socketDataStatic.length; index++) {
        if(this.state.selectedCmdty === this.props.socketDataStatic[index].I){
          dec= this.props.socketDataStatic[index].dec;
          break;
        }
      }
      if(price !=='' && !isNaN(price) && price !== 0){
        price=Number(price).toLocaleString(navigator.language,{minimumFractionDigits:dec,maximumFractionDigits:dec});
        // price=(price).replace(getSeparator(navigator.language,'group'),"");
        // price=price.toFixed(dec);
        if(price === "NaN" || (price === "" && price != 0)){
        price="";
        }
      }
      if(event.target.value === "" || event.target.value === decimal){
        price=event.target.value;
      }
      this.setState({Price: price});
      this.checkInputData(this.state.cmdtyID,price,this.state.selectedQuantityLmt,this.state.selectedMeasureLmt,this.state.OrderType,this.state.dealTypeKey,this.state.selectedRmk,this.state.ValidtyKey,this.state.time);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurPrice', component:"LimitOrderComponent"});
    }
  }

  onBlurTime = (event) =>{
    try{
      let time = event.target.value
      this.setState({time:event.target.value});
      this.setState({actualTime:moment(event.target.value+" "+this.state.timeFormat, ["h:mm A"]).format("HH:mm"),
      validationTime:(event.target.value).substring(0, 2)});
      this.checkInputData(this.state.cmdtyID,this.state.Price,this.state.selectedQuantityLmt,event.target.text,this.state.OrderType,this.state.dealTypeKey,this.state.selectedRmk,this.state.ValidtyKey,time);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurTime', component:"LimitOrderComponent"});
    }
  }

  handleChangeDate = (date) => {
    try{
      this.setState({startDate: date});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleChangeDate', component:"LimitOrderComponent"});
    }
  }

selectDealType = (dealType,val) => {
  try{
    let orderType;
    this.setState({DealType: dealType});
		this.setState({dealTypeKey: val});
    if(dealType === 'BUY'|| dealType === 'SELL'){
      orderType=2;
      this.setState({OrderType:orderType});
    }
    else{
        orderType=3;
        this.setState({OrderType:orderType});
        // DAY only for stop orders
        if (this.props.userDetail.hasOwnProperty('isOnlyDayValForStopOrd') && this.props.userDetail.isOnlyDayValForStopOrd) {
            this.setState({
                Validty: "DAY",
                ValidtyKey: "0",
            })
        }
    }
    this.checkInputData(this.state.cmdtyID,this.state.Price,this.state.selectedQuantityLmt,this.state.selectedMeasureLmt,orderType,val,this.state.selectedRmk,this.state.ValidtyKey,this.state.time)
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'selectDealType', component:"LimitOrderComponent"});
  }
}

closeLmtModal = (event) => {
  try{
    this.setState({showLmtDialog:false});
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'closeLmtModal', component:"LimitOrderComponent"});
  }
}
onKeyPress(event) {
  try{
    if (event.which === 13 /* Enter */) {
      event.preventDefault();
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'onKeyPress', component:"LimitOrderComponent"});
  }
}

getwsData= (CmdtyPair, Quantity, Measure, DealType, Price, OrderType, OMT,PCT,remark,ValidityType,CTID,datetime,VD,baseInstId)=>{
  try{
    const user = JSON.parse(localStorage.getItem('user'));
      const AccDet=JSON.parse(localStorage.getItem('DFA'));
    const platform = localStorage.getItem('platform');
    let symbol;
    let priceValue = Price;
    let quant = Quantity;

    if (!priceValue) {
      priceValue = 0;
    }
    if (quant === '') {
      quant = 0;
    }
    var obj={};
    obj.language=navigator.language;
    obj.platform=platform;
      obj.MT="NEW_ORDER";
      obj.UID=user.UID;
      obj.UCD=user.trdCode;
      obj.UD=user.UD;
      obj.IID=CmdtyPair;
      obj.PQ=parseFloat(quant);
      obj.DT=DealType;
      obj.R=parseFloat(Price);
      obj.OT=OrderType;
      obj.CID=user.location;
      obj.AC=AccDet.C;
      obj.AD=AccDet.D;
      if(Measure==="")
      {
        obj.SC="";
      }else{
        obj.SC=Measure;
      }
      obj.ST="";
      obj.OMT=OMT;
      obj.PCT=PCT;
      obj.RMK=remark;
      obj.DRMK=" ";
      obj.MD=-1;
      obj.VD=VD;
      obj.SID=user.SID;
      obj.CTID=CTID;
      obj.VT=ValidityType; //validity, ValidityType class
      obj.OMC=0;//order modification count
      obj.VTE=datetime;//epoch UTC timestamp
      obj.BSIID=baseInstId
      obj.browser=navigator.userAgent
      this.setState({
        wsDATA:obj
      })
      return obj
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'getwsData', component:"LimitOrderComponent"});
  }
}
  // orderValidate
  lmtOrderValidate = (Com, selectedQuantity, selectedMeasure, Price,cmdtyRate,ValueDate,dealType,dealTypeKey,OrderType, tradeDayEnd) =>{
    try{
      // console.log("selectedQuantity " +selectedQuantity);
      var selectedQuantity =  unformatLang(selectedQuantity);
      const defaultAcc = getDefaultAcdAccount(this.props.ACD)
      this.setState({
        defaultAccountIsActive: Boolean(Number(defaultAcc.isActiveAcc)),
      });
      let flag = 0;
      if (Price == decimal) {
        flag = 1;
        this.setState({errorMsg:"enterValidPricemsg"});
        this.setState({showLmtDialog:true});
      }else if(this.props.orderStatus===2 || this.props.orderStatus===1){
        this.setState({orderSocketClosed: true});
      }
      else{
      var Price = unformatLang(Price);
      selectedQuantity=selectedQuantity+"";
        var tempQ= selectedQuantity;
        var check= selectedQuantity.slice(selectedQuantity-1);

        if(check.toUpperCase()==='K')
        {
          tempQ= selectedQuantity.slice(check, -1);
          tempQ=parseInt(tempQ)*1000;
        }
        if(Com===1 || this.state.isCustInst){
          selectedMeasure="";
        }
        var error = '';
        this.setState({errorMsg:""});
        if(parseInt(this.props.status) !== 0){
          this.setState({errorMsg:"noRatesMsg"});
        }
        if(parseFloat(tempQ) === 0){
          flag=1;
          this.setState({errorMsg:"qtyNotZeroMsg"});
        }
        if(this.props.userDetail.enableCustTradeQtyRO === 1 && tempQ % 1 !== 0){
          flag=1;
          this.setState({errorMsg:"fractionDigitErrMsg"});
        }

        if(Price ==='' && flag!==1){
          flag = 1;
          this.setState({errorMsg:"enterGreaterPriceMsg"});
        }
        let flag2=0;
          if ((Price === "0"|| Price === 0) && flag!==1 ) {
            flag = 1;
            flag2=1;
            this.setState({errorMsg:"enterGreaterPriceMsg"});
          }

          if(parseFloat(Price) === 0 && flag!==1){
            flag=1;
            this.setState({errorMsg:"enterGreaterPriceMsg"});
          }
         
        var sockCmdty=this.props.socketData.get(this.state.cmdtyID);
        let askRate = sockCmdty.ask
        let bidRate = sockCmdty.bid
        if(askRate){
          askRate = parseFloat(sockCmdty.ask)-this.state.stkWiseAskMarkup;
        }
        if(bidRate){
          bidRate = parseFloat(sockCmdty.bid)-this.state.stkWiseBidMarkup;
        } 
        var minPrice=parseFloat(sockCmdty.OV);
        var maxPrice=parseFloat(sockCmdty.MXOV);
        Price=parseFloat(Price);
        let baseInstId = sockCmdty.BI;
      if (askRate && bidRate) {
        if (askRate > bidRate) {
          if (bidRate < Price && Price < askRate) {
            flag = 1;
            if (this.props.userDetail.showPrice === undefined || this.props.userDetail.showPrice === "BOTH") {
              this.setState({ errorMsg: "placeOrdOutsideSpreadMsg" });
            } else {
              this.setState({ errorMsg: "priceEnteredTooCloseMsg" });
            }
          }
        }
        else {
          if (askRate < Price && Price < bidRate) {
            flag = 1;
            if (this.props.userDetail.showPrice === undefined || this.props.userDetail.showPrice === "BOTH") {
              this.setState({ errorMsg: "placeOrdOutsideSpreadMsg" });
            } else {
              this.setState({ errorMsg: "priceEnteredTooCloseMsg" });
            }
          }
        }
      }
        var rate = dealTypeKey ===1 ? askRate : bidRate;
        if(Math.abs(rate - Price) < minPrice && flag !==1 ){
            flag = 1;
            this.setState({errorMsg:"priceEnteredTooCloseMsg"});
        }
          // if(maxPrice > 0 && flag !==1){
          if(flag !==1){
            if(Math.abs(rate - Price) > maxPrice){
                flag = 1;
                this.setState({errorMsg:"ordFarFromCurrSpreadMsg"});
            }
          }
        if((Price && flag2!==1) && flag!==1){
          if (dealTypeKey === 1 && flag!==1) {
            if(OrderType === 2){
              if (Price >askRate) {
                flag = 1;
                this.setState({errorMsg:"priceEnterWrngSideOfMkt"});
              }
            }else {
              if (Price < askRate) {
                flag = 1;
                this.setState({errorMsg:"priceEnterWrngSideOfMkt"});
              }
            }

          } else if (dealTypeKey === 0 && flag!==1) {
            if(OrderType === 2){
                if (Price< bidRate) {
                  flag = 1;
                  this.setState({errorMsg:"priceEnterWrngSideOfMkt"});
                }
            }else {
              if (Price > bidRate) {
                flag = 1;
                this.setState({errorMsg:"priceEnterWrngSideOfMkt"});
              }
            }
          }
      }
        if(this.state.Validty === 'GTD'){
          if(this.state.startDate === null && flag!==1)
            {
              flag = 1;
              this.setState({errorMsg:"invalidDate"});
            }
            var newdate=moment().add(this.props.userDetail.valDaysLimit,'days');
            newdate.set({hour:hour,minute:min,second:0,millisecond:0})
            var momentA = moment(this.state.startDate);
            var valTime=""+moment().local().format("hh:mm");
            var hour=parseInt(valTime.substring(0, valTime.indexOf(":")));
            var min =parseInt(valTime.substring(valTime.indexOf(":") + 1));
            var endTime = moment().startOf('day');
            if(momentA.isBefore(tradeDayEnd))
            {
              flag =1;
              this.setState({errorMsg:"expTimeGreaterThanCurr"});
            }else if(momentA.isAfter(newdate)){
              flag =1;
              this.setState({errorMsg:i18next.t("greaterThan")+" " +this.props.userDetail.valDaysLimit+ " "+i18next.t("withinDays")});
            }
          }
          if(this.state.Validty === 'GTT'){
            if(this.state.startDate === null && flag!==1)
              {
                flag = 1;
                this.setState({errorMsg:"invalidDate"});
              }
              if(this.state.time === '' && flag!==1)
              {
                flag = 1;
                this.setState({errorMsg:"invalidTime"});
              }
            var newdate=moment().add(this.props.userDetail.valDaysLimit,'days');
            newdate.set({hour:hour,minute:min,second:0,millisecond:0})
            var momentA = moment(this.state.startDate);
            var valTime=""+this.state.actualTime;
            var hour=parseInt(valTime.substring(0, valTime.indexOf(":")));
            var min =parseInt(valTime.substring(valTime.indexOf(":") + 1));
            momentA.set({hour:hour,minute:min,second:0,millisecond:0})
            var endTime = moment().add(5, 'minute');
            var currentTime =moment();

            if(this.state.validationTime>=13){
              flag =1;
              this.setState({errorMsg:"twelveHrsValidation"});
            }
            else if(momentA.isBefore(currentTime)){
              flag =1;
              this.setState({errorMsg:"expTimeGreaterThanCurr"});
            }
            else if(momentA.isBefore(endTime)){
              flag =1;
              this.setState({errorMsg:"greaterThanFiveMin"});
            }
            else if(momentA.isAfter(newdate)){
              flag =1;
              this.setState({errorMsg:i18next.t("greaterThan")+" " +this.props.userDetail.valDaysLimit+ " "+i18next.t("withinDays")});
            }
          }
          if(tempQ === ''){
            flag=1;
            this.setState({errorMsg:"minEnterQty"});
          }

        let time;
        if(this.state.Validty === 'DAY'){
          time=moment().format('YYYY-MM-DD');
        }else if(this.state.Validty === 'GTD'){
          const sDate=moment(this.state.startDate).format('YYYY-MM-DD');
          let start_time = moment().local().format("HH:mm");
          let datetimeA = moment(sDate + " " + "00:00");
          var date=datetimeA;
          time=moment(this.state.startDate).format('YYYY-MM-DD');
        }else if(this.state.Validty === 'GTT'){
          const sDate=moment(this.state.startDate).format('YYYY-MM-DD');
          let start_time = this.state.actualTime;
          let datetimeA = moment(sDate + " " + start_time);
          var date=datetimeA;
          time=date.utc().valueOf();
        }else{
          var date = moment();
          date.format();
          time=date.utc().valueOf();
        }
        if(flag === 1){
          this.setState({showLmtDialog:true});
        } else{
          if(Number(defaultAcc.isActiveAcc) && this.props.userDetail.canTrade)
          {
            const user = JSON.parse(localStorage.getItem('user'));
            var CTID =user.location+"_"+user.SID+Math.floor((Math.random() * 1000000) + 1);
            this.props.setOrdersCTID(CTID);
            var convVal;
            if(this.state.COM===1){
              convVal=1;
            }else{
              convVal=this.state.convFactor.get(selectedMeasure);
            }
            this.handleLmtOrder(this.state.COM,this.state.cmdtyID, selectedQuantity, selectedMeasure,dealTypeKey, Price,this.state.OrderType,ValueDate,this.state.selectedRmk,this.state.ValidtyKey,CTID,time,convVal,baseInstId);
            const showPrice = this.props.userDetail.showPrice===undefined||this.props.userDetail.showPrice==="undefined"?"BOTH":this.props.userDetail.showPrice;
            var DealType=showPrice==="ASK"||showPrice==="BOTH"?'BUY':'SELL';
            this.setState({DealType: i18next.t(DealType),showPrice:this.props.userDetail.showPrice});
            this.setState({OrderType:2});
            this.setState({Validty:this.props.userDetail.validityCodeForTrader[0].validityType});
            this.setState({ValidtyKey:this.props.userDetail.validityCodeForTrader[0].validityType==="GTC"?"1":this.props.userDetail.validityCodeForTrader[0].validityType==="DAY"?"0":
              this.props.userDetail.validityCodeForTrader[0].validityType==="GTD"?"6":"60"});
            this.setState({Price: ''});
            if(this.props.userDetail.storetradeqty === "0"){
              this.setState({selectedQuantityLmt :""});
            }
            this.refs.comments.value="";
            this.setState({selectedRmk:""});
            this.setState({time:moment().add(6, 'minute').format("hh:mm"),
            validationTime:(moment().add(6, 'minute').format("hh:mm")).substring(0, 2),
            startDate: moment(),
            timeFormat:moment().add(6, 'minute').format("A"),
            actualTime:moment(moment().add(6, 'minute').format("hh:mm")+" "+moment().add(6, 'minute').format("A"), ["h:mm A"]).format("HH:mm")});
            this.props.closedLmtModal(false,this.props.lmtKeyValue);
          }else {
            this.setState({showtrdFlagModal:true});
          }
        }
      }
      
    } catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'lmtOrderValidate', component:"LimitOrderComponent"});
    }
  }

  @track((props, state) => ({ 
    widgetDetails: { tab: "LMT", originFunction: "handleLmtOrder", event: appConstants.trackingEvents.PLACE_ORDER},
    ordDetails: [wsData]
  }))

  handleLmtOrder = (Com,CmdtyPair, selectedQuantity, selectedMeasure, dealTypeKey, Price, OrderType, ValueDate, remark, ValidityType, CTID, datetime, convValue, baseInstId) => {
		try{
      selectedQuantity=selectedQuantity+"";
      var tempQ= selectedQuantity;
      var check= selectedQuantity.slice(selectedQuantity-1);
      if (check.toUpperCase() === 'K') {
        tempQ= selectedQuantity.slice(check, -1);
        tempQ=parseInt(tempQ)*1000;
      }
      var OMT=1;
      var PCT=2;
      let processedData={
        IID:CmdtyPair,
        PQ:tempQ,
        SC:selectedMeasure,
        DT:dealTypeKey,
        R:Price,
        OT:OrderType,
        OMT:OMT,
        PCT:PCT,
        RMK:remark,
        VT:ValidityType,
        CTID:CTID,
        VTE:datetime,
        VD:ValueDate,
        BSIID:baseInstId,
        language:navigator.language,
        platform:localStorage.getItem('platform'),
        MT:"NEW_ORDER",
        browser:navigator.userAgent
        }
      this.setState({processedData})
      this.props.handleSellBuyLMTOrder(CmdtyPair, tempQ, selectedMeasure, dealTypeKey, Price, OrderType, OMT, PCT, remark, ValidityType, CTID, datetime, ValueDate, baseInstId);
      wsData=this.getwsData(CmdtyPair, tempQ, selectedMeasure, dealTypeKey, Price, OrderType, OMT, PCT, remark, ValidityType, CTID, datetime, ValueDate, baseInstId)
      let inputData=this.state.inputData;
      let apiValidateData=[{inputData},{processedData},{wsData}]
      // console.log(JSON.stringify(apiValidateData))
      this.props.validateOrder(JSON.stringify(apiValidateData))
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleLmtOrder', component:"LimitOrderComponent"});
    }
  }

  clearOrder= (event) => {
    try{
      this.setState({Price: ""});
      this.setState({selectedQuantityLmt: ""});
      this.refs.comments.value="";
      this.setState({selectedRmk:""});
      this.setState({time:moment().add(6, 'minute').format("HH:mm"),
      validationTime:(moment().add(6, 'minute').format("HH:mm")).substring(0, 2),
      startDate: moment(),
      //actualTime:moment(moment().add(6, 'minute').format("hh:mm")+" PM", ["h:mm A"]).format("HH:mm"),
      actualTime:moment(moment().add(6, 'minute').format("hh:mm") + " " + moment().add(6, 'minute').format("A"), ["h:mm A"]).format("HH:mm"),
      timeFormat:moment().add(6, 'minute').format("A")});
      this.props.closedLmtModal(false,this.props.lmtKeyValue);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'clearOrder', component:"LimitOrderComponent"});
    }
  }
  onBlurLMTRmk= (event) =>{
    try{
      const rmk=event.target.value;
      this.setState({selectedRmk: rmk});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurLMTRmk', component:"LimitOrderComponent"});
    }
  }

  closeLmtOrdConfirmMsg = () => {
    try{
      this.props.closeOrdConfirmMsg();
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeLmtOrdConfirmMsg', component:"LimitOrderComponent"});
    }
  }

  onTimeChange  = (time) => {
    try{
      this.setState({time:time});
      this.setState({actualTime:moment(time+" "+this.state.timeFormat, ["h:mm A"]).format("HH:mm"),
      validationTime:(time).substring(0, 2),});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onTimeChange', component:"LimitOrderComponent"});
    }
  }

  closeTrdFlagModal = (event) => {
    try{
      this.setState({showtrdFlagModal:false, defaultAccountIsActive: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeTrdFlagModal', component:"LimitOrderComponent"});
    }
  }

  onSelectTimeFormat=(timeFormat) =>{
    try{
      this.setState({timeFormat:timeFormat});
      this.setState({actualTime:moment(this.state.time+" "+timeFormat, ["h:mm A"]).format("HH:mm")});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onSelectTimeFormat', component:"LimitOrderComponent"});
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.check !== this.props.check){
      return true;
    }
    if(nextState.cmdtyIndex !== this.state.cmdtyIndex){
      return true;
    }
    if(nextProps.status !== this.props.status){
      return true;
    }
    // if(nextProps.ordcnfrmsg !== this.props.ordcnfrmsg){
    //   console.log("ordcnfrmsg ");
    //       return true;
    // }
    if(nextProps.userDetail.storetradeqty !== this.props.userDetail.storetradeqtyy){
      return true;
    }
    if(nextState.selectedRmk !== this.state.selectedRmk){
      return true;
    }
    if(nextState.convFactor !== this.state.convFactor){
      return true;
    }
    if(nextState.selectedQuantityLmt !== this.state.selectedQuantityLmt){
      return true;
    }
    if(nextState.selectedMeasureLmt !== this.state.selectedMeasureLmt){
      return true;
    }
    if(nextState.MEASURE !== this.state.MEASURE){
      return true;
    }
    if(nextState.Price !== this.state.Price){
      return true;
    }
    if(nextState.DealType !== this.state.DealType){
          return true;
    }
    if(nextState.Validty !== this.state.Validty){
          return true;
    }
    if(nextState.ValidtyKey !== this.state.ValidtyKey){
          return true;
    }
    if(nextState.showLmtDialog !== this.state.showLmtDialog){
          return true;
    }
    if(nextState.errorMsg !== this.state.errorMsg){
          return true;
    }
    if(nextState.time !== this.state.time){
          return true;
    }
    if(nextState.startDate !== this.state.startDate){
          return true;
    }
    if(nextState.CTID !== this.state.CTID){
          return true;
    }
    if(nextState.showtrdFlagModal !== this.state.showtrdFlagModal){
      return true;
    }
    return false;
  }

  afterOpenModal() {
    try{
      const thisComponent = this.refs.errorMSG;
      //const allCssStyleRules = this.props.selectedCssColorTheme;
      // const elementsData = [
      //   {"classNames":"header","elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"part1TabContent","elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"part2TabContent","elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"lmtSubmit","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      //   {"classNames":"lmtClose","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      //   {"classNames":"lmtRateDiff","elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"msg","elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"mdlWrap","elementType":"normal", "applyTo":"single", "tagNames":"div"}
      // ];
      // const directionData=[
      //   {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
      //   {"classNames":"closeIconLmt","elementType":"normal", "applyTo":"all", "tagNames":"div"},
      //   {"classNames":"msgTitle","elementType":"normal", "applyTo":"all", "tagNames":"div"},
      //   {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
      //   {"classNames":"cmdtyType","elementType":"normal", "applyTo":"all", "tagNames":"p"},
      //   {"classNames":"col3","elementType":"normal", "applyTo":"all", "tagNames":"div"},
      //   {"classNames":"col4","elementType":"normal", "applyTo":"all", "tagNames":"div"},
      //   {"classNames":"trdMeasureDrpDown","elementType":"normal", "applyTo":"all", "tagNames":"button"},
      //   {"classNames":"rightPart","elementType":"normal", "applyTo":"all", "tagNames":"div"},
      //   {"classNames":"trdDropdownInput","elementType":"normal", "applyTo":"all", "tagNames":"input"}
      // ];
      //applyStyle(thisComponent, allCssStyleRules, elementsData);
      //setDirection(thisComponent,directionData,this.props.selectedLang);
      const directionData = [
        {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"trdCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"errorPara", "elementType":"normal", "applyTo":"all", "tagNames":"p"},
        {"classNames":"rightPart","elementType":"normal", "applyTo":"all", "tagNames":"div"},
      ];
      setDirection(thisComponent,directionData,this.props.selectedLang);
      const hoverElementsClassNames = [
          {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
          {"elmToHover":thisComponent.getElementsByClassName("lmtSubmit")[0], "classNames":"lmtSubmit"},
          {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[0], "classNames":"lmtClose"}
      ];
      //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"LimitOrderComponent"});
    }
  }

  closeorderSocketClosedModal = (event) => {
    try{
      this.setState({orderSocketClosed:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeorderSocketClosedModal', component:"LimitOrderComponent"});
    }
  }
  checkInputData=(cmdtyId,price,selectedQuantity,selectedMeasure,OrderType,dealTypeKey,rmk,validtyKey,time)=>{
    try{
      let inputData= {
        IID:cmdtyId,
        PQ:selectedQuantity,
        SC:selectedMeasure,
        R:price,
        DT:dealTypeKey,
        OT:OrderType,
        RMK:rmk,
        VT:validtyKey,
        VTE:time,
        language:navigator.language,
        platform:localStorage.getItem('platform'),
        MT:"NEW_ORDER",
        browser:navigator.userAgent
      }
      this.setState({inputData})
      // console.log(inputData)
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'checkInputData', component:"LimitOrderComponent"});
    }
  }

  handleValidityTypes = () => {
    // get param from login response
    const displayDAYOnly = this.props.userDetail.hasOwnProperty('isOnlyDayValForStopOrd') && this.props.userDetail.isOnlyDayValForStopOrd;
    if (displayDAYOnly && this.state.OrderType === 3) {
        return this.props.userDetail.validityCodeForTrader.filter(validity => validity.validityType === 'DAY');
    } else {
        return this.props.userDetail.validityCodeForTrader;
    }
}

  render() {
    const closeIcon =<MUIIconWithTooltip icon={'Close'} className={'closeBtn'} title={i18next.t("close")}/>
    const { selectedMeasureLmt, selectedQuantityLmt, Price, DealType, Validty,DFLMT,MEASURE,OrderType,time,showPrice} = this.state;
    const tradeDayEnd = moment(this.props.userDetail.dayEndTime).utc().format('YYYY-MM-DD')

     let CmdtyAsk;
    let CmdtyBid;
    let CmdtyAskArray;
    let CmdtyBidArray;
    let ValueDate;
    let D1;
    let rateDiff;
    let variationInAsk;
    let CmdtyBidFontPosStart=0;let CmdtyBidFontPosEnd=0;
    let CmdtyAskFontPosStart=0;let CmdtyAskFontPosEnd=0;
    let socketDataMap=this.props.socketData.get(this.state.selectedCmdty);
    CmdtyAsk = socketDataMap.ask;
    CmdtyBid = socketDataMap.bid;
     
    let CmdtyAskKey
    let CmdtyBidKey

    if(DealType === "BUY" || DealType === "SELL"){
      CmdtyAskKey = 'LA'
      CmdtyBidKey = 'LB'
    } else if(DealType === "STOPBUY" || DealType === "STOPSELL"){
      CmdtyAskKey = 'SA'
      CmdtyBidKey = 'SB'
    } else {
      CmdtyAskKey = 'ask'
      CmdtyBidKey = 'bid'
    }

    if(CmdtyAsk){
      CmdtyAsk = (parseFloat(socketDataMap[CmdtyAskKey])-this.state.stkWiseAskMarkup).toFixed(socketDataMap.dec);
    }
    if(CmdtyBid){
      CmdtyBid = (parseFloat(socketDataMap[CmdtyBidKey])-this.state.stkWiseBidMarkup).toFixed(socketDataMap.dec);
    }
    var mf = JSON.parse(socketDataMap.PTN).mf;
    var rf = JSON.parse(socketDataMap.PTN).rf;
    rateDiff= parseFloat(CmdtyBid) && parseFloat(CmdtyAsk) ? Math.abs(Math.round(((parseFloat(CmdtyBid).toFixed(socketDataMap.dec)-parseFloat(CmdtyAsk).toFixed(socketDataMap.dec)))*mf)).toFixed(rf) : '';
    D1 = socketDataMap.D1;
    variationInAsk = socketDataMap.variationInAsk;
    ValueDate=socketDataMap.VD;
    const variationInBid = socketDataMap.variationInBid;
    let dec = socketDataMap.dec;
    if (CmdtyBid) {
      CmdtyBidArray = Number(parseFloat(CmdtyBid)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }).split('');
      CmdtyBidFontPosStart = CmdtyBidArray.length - JSON.parse(socketDataMap.PTN).bs;
      CmdtyBidFontPosEnd = (CmdtyBidArray.length - JSON.parse(socketDataMap.PTN).se) - 1;
    }
    if (CmdtyAsk) {
      CmdtyAskArray = Number(parseFloat(CmdtyAsk)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }).split('');;
      CmdtyAskFontPosStart = CmdtyAskArray.length - JSON.parse(socketDataMap.PTN).bs;
      CmdtyAskFontPosEnd = (CmdtyAskArray.length - JSON.parse(socketDataMap.PTN).se) - 1;
    }
    const isWeekday = date => {
      const day = new Date(date).getDay();
      return day !== 0 && day !== 6;
    };
      
    // const showPrice = this.props.userDetail.showPrice===undefined||this.props.userDetail.showPrice==="undefined"?"BOTH":this.props.userDetail.showPrice;
    const stkCodeClass = MEASURE.length == 1 ? true : false;
    // const disabledSellStopSell = parseInt(this.props.status) !== 0 || parseFloat(CmdtyAsk) <= 0
    // const disabledBuyStopBuy = parseInt(this.props.status) !== 0 || parseFloat(CmdtyBid) <= 0

    //OSP -- One Sided Pricing, CmdtyBid -> Sell Price, CmdtyAsk -> Buy Price
    const disabledBtnOSP = parseInt(this.props.status) !== 0 || (!parseFloat(CmdtyBid) && (DealType === 'SELL' || DealType === 'STOPSELL')) || (!parseFloat(CmdtyAsk) && (DealType === 'BUY' || DealType === 'STOPBUY'))
    const defaultAcc = getDefaultAcdAccount(this.props.ACD)
    
    return (
			<div id="lmtOrd">
        <div className={`${styles.header} header`}>
          <span className={`${styles.msgTitle} msgTitle`}>{i18next.t('placeOrd')} </span>
          <span onClick={this.clearOrder} className={`${styles.closeImg} closeIcon closeIconLmt`} id="lmtCloseModalIcon">{closeIcon}</span>
        </div>

        <div className={`${styles.trdwrapper} ${this.props.language}`}>
          <div className={`${styles.lmtWidgetwrapper}`}>
            <Modal isOpen={this.state.orderSocketClosed} id="lmtOrdConnErrModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
              <div ref="errorMSG" className="mdlWrap" >
                <div className={`${styles.header} header`}>
                  <span className={`${styles.msgTitle}`}>{i18next.t("error")}</span>
                </div>
                <span onClick={this.closeorderSocketClosedModal} id="lmtCloseOrdModal" className={`${styles.closeImg} closeIcon closeIconLmt commonCloseIcon`}>{closeIcon}</span>
                <div className={`${styles.msg} msg commonMsgDir`}>
                  <p>{i18next.t("orderStatus")}</p>
                </div>
              </div>
            </Modal>

            <Modal isOpen={this.state.showLmtDialog} className={styles.warningModal} id="errorMsgModal" onAfterOpen={this.afterOpenModal}>
              <div ref="errorMSG" className="mdlWrap" >
                <div className={`${styles.header} header`}>
                  <span className={`${styles.msgTitle} msgTitle`}>{i18next.t('error')}</span>
                  <span onClick={this.closeLmtModal} id="lmtCloseOrdModal" className={`${styles.closeImg} closeIcon closeIconLmt commonCloseIcon`}>{closeIcon}</span>
                </div>
                <div className={`${styles.msg} msg commonMsgDir`} id="errorMsg">
                  {this.state.errorMsg && this.state.errorMsg != "" ? <p className={`errorPara`}>{i18next.t(this.state.errorMsg)}</p> : null}
                </div>
              </div>
            </Modal>

            <Modal isOpen={this.state.showtrdFlagModal} className={styles.warningModal} id="trdingErrorModal"  onAfterOpen={this.afterOpenModal}>
              <div ref="errorMSG" className="mdlWrap" >
                <div className={`${styles.header} header`}>
                  <span className={`${styles.msgTitle} msgTitle`}>{i18next.t('error')}</span>
                  <span onClick={this.closeTrdFlagModal} className={`${styles.closeicon} closeIcon closeIconLmt commonCloseIcon`} id="lmtCloseTrdModal">{closeIcon}</span>
                </div>
                <div className={`${styles.msg} msg commonMsgDir`}>
                  <p className={`errorPara`}>{i18next.t(!this.state.defaultAccountIsActive ? displayInActiveAccMsg(defaultAcc.D,defaultAcc.C) : 'tradingDisbleByDealerMsg')}</p>
                </div>
              </div>
            </Modal>

            <div className={`${styles.part1TabContent} part1TabContent`}>
              {showPrice==="BOTH" && this.props.userDetail.showPriceSpread===true?
                <div className={`${styles.lmtRateDiff} ${styles.lmt_rateDiff} lmtRateDiff`} id="rateDiff">
                  {parseInt(this.props.status) === 0 ? <span> {rateDiff} </span> : <span> {rateDiff} </span>}
                </div>
              : null}

              {showPrice==="BOTH" ?
                <div className={variationInBid === 'increment' ? `${styles.increment} ${styles.lmtSell} text-center` : `${styles.decrement} ${styles.lmtSell} text-center`} >
                  <button className={`${styles.lmtBuyRate} ${styles.disabled} buyBg`}  id="lmtBuyBtn">
                    {parseInt(this.props.status) === 0 && CmdtyBidArray && parseFloat(CmdtyBid) > 0 ?
                      <div>
                        {variationInBid ?
                          <div className={styles.arrowPriceUp}><span className={variationInBid === 'increment' ? `upArrow` : `downArrow`}/></div>
                        : null}
                        <p>
                          {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                            return (
                              <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                            );
                          })}
                        </p>
                      </div>
                    :
                      <div className={`${styles.priceDownDiv} priceDownDiv`}>
                      {parseFloat(CmdtyBid) > 0 && parseInt(this.props.status) !== 0  ?
                        <div>
                        <p>
                          {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                            return (
                              <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                            );
                          })}
                        </p>
                      </div>:<p>- - - -</p>}
                      </div>
                    }
                  </button>
                </div>
              : null}

              {showPrice==="BID" ?
                <div className={variationInBid === 'increment' ? `${styles.increment} ${styles.lmtOneSidedPrice} text-center` : `${styles.decrement} ${styles.lmtOneSidedPrice} text-center`} >
                  <button className={`${styles.lmtBuyRate} ${styles.disabled} buyBg`}  id="lmtBuyBtn">
                    {parseInt(this.props.status) === 0 && CmdtyBidArray && parseFloat(CmdtyBid) > 0 ?
                      <div>
                        {variationInBid ?
                          <div className={styles.arrowPriceUp}><span className={variationInBid === 'increment' ? `upArrow` : `downArrow`}/></div>
                        : null}
                        <p>
                          {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                            return (
                              <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                            );
                          })}
                        </p>
                      </div>
                    :

                      <div className={`${styles.priceDownDiv} priceDownDiv`}>
                    {parseFloat(CmdtyBid) > 0 && parseInt(this.props.status) !== 0 ?
                      <div>

                        <p>
                          {CmdtyBidArray && CmdtyBidArray.map((item, index) => {
                            return (
                              <span className={(index >= CmdtyBidFontPosStart && index <= CmdtyBidFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                            );
                          })}
                        </p>
                      </div>:<p>- - - -</p>}
                       </div>
                    }
                  </button>
                </div>
              : null}

              {showPrice==="BOTH" ?
                <div className={variationInAsk === 'increment' ? `${styles.increment} ${styles.lmtBuy} text-center` : `${styles.decrement} ${styles.lmtBuy} text-center`}>
                  <button className={`${styles.lmtSellRate} ${styles.disabled} sellBg`}  id="lmtSellBtn">
                    {parseInt(this.props.status) === 0 && CmdtyAskArray  && parseFloat(CmdtyAsk) > 0?
                      <div>
                        {variationInAsk ?
                          <div className={styles.arrowPriceDown}><span className={variationInAsk === 'increment' ? `upArrow` : `downArrow`}/></div>
                        : null}
                        <p>
                          {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                            return (
                              <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                            );
                          })}
                        </p>
                      </div>
                    :
                      <div className={`${styles.priceDownDiv} priceDownDiv`}>
                    {parseFloat(CmdtyAsk) > 0 && parseInt(this.props.status) !== 0 ?
                      <div>

                        <p>
                          {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                            return (
                              <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                            );
                          })}
                        </p>
                      </div>:<p>- - - -</p>}
                       </div>
                    }
                  </button>
                </div>
              :null}

              {showPrice==="ASK" ?
                <div className={variationInAsk === 'increment' ? `${styles.increment} ${styles.lmtOneSidedPrice} text-center` : `${styles.decrement} ${styles.lmtOneSidedPrice} text-center`}>
                  <button className={`${styles.lmtSellRate} ${styles.disabled} sellBg`}  id="lmtSellBtn">
                    {parseInt(this.props.status) === 0 && CmdtyAskArray &&  parseFloat(CmdtyAsk) > 0 ?
                      <div>
                        {variationInAsk ?
                          <div className={styles.arrowPriceDown}><span className={variationInAsk === 'increment' ? `upArrow` : `downArrow`}/></div>
                        : null}
                        <p>
                          {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                            return (
                              <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                            );
                          })}
                        </p>
                      </div>
                    :
                      <div className={`${styles.priceDownDiv} priceDownDiv`}>
                      {parseFloat(CmdtyAsk) > 0 && parseInt(this.props.status) !== 0 ?
                        <div>

                        <p>
                          {CmdtyAskArray && CmdtyAskArray.map((item, index) => {
                            return (
                              <span className={(index >= CmdtyAskFontPosStart && index <= CmdtyAskFontPosEnd ? `${styles.largefont}` : null)}>{item}</span>
                            );
                          })}
                        </p>
                      </div>:<p>- - - -</p>}
                       </div>
                    }
                  </button>
                </div>
              : null}
              {/*parseInt(this.props.status) !== 0 ?
                <div className={`${styles.noRatesMsgLmtDiv} noRatesMsgDiv`} style={noRatesMsgDiv}><p>{i18next.t('noRatesAvailMsg')}</p></div>
              : null*/}
            </div>

            <div>
              <div className={`${styles.part2TabContent} part2TabContent ${this.props.selectedCssColor}`}>
                <div className={`${styles.rightPartLMT} rightPart`}>
                  <div className={`${styles.col3} col3`} style={this.props.selectedLang.col3}>
                    <p className="cmdtyType">{D1}</p>
                  </div>

                  <div className={this.state.COM===2 && !this.state.isCustInst ? `${styles.col5}` : `${styles.col8} eurQty`} id="LMTQtyMenu" style={this.props.selectedLang.col5}>
                    <ButtonToolbar>
                      <DropdownButton id="dropdown-size-medium" className="trdDropDown btnText" >
                        {DFLMT.map((qntity) => {
                          return (
                            <MenuItem onClick={this.quantitySelectionLmt} id="lmtOrdQauntityMenu" className="dropDownList" >{qntity}</MenuItem>
                          );
                        })}
                      </DropdownButton>
                    </ButtonToolbar>
                    <input type="text" autoComplete="off" className={`${styles.lmtDropdownInput} trdDropdownInput`} id="lmtDropQuantity" onBlur={this.onBlurLMT} value={selectedQuantityLmt} onChange={this.quantityTypedLmt} onKeyPress={this.checkNumberValue} placeholder={i18next.t("quantity")} />
                  </div>

                  {this.state.COM===2  && !this.state.isCustInst ?
                    <div className={`${styles.col4} ${this.props.selectedCssColor}`} style={this.props.selectedLang.col4} id="lmtUntMeasure">
                      <ButtonToolbar>
                        <DropdownButton title={selectedMeasureLmt} id="dropdown-size-medium" className={stkCodeClass === true ? "trdDropDown btnText singleOptn":"trdDropDown btnText"} >
                          {MEASURE && MEASURE.map((unitMeasure) => {
                            return (
                              <MenuItem onClick={this.selectMeasureLmt} id="lmtOrdSelectMeasure" className="dropDownList" >{unitMeasure}</MenuItem>
                            );
                          })}
                        </DropdownButton>
                      </ButtonToolbar>
                    </div>
                  : null}
                </div>

                <div className={`${styles.rightPartLMT} rightPart`}>
                  {this.props.userDetail.STOP_ORD === true ?
                    <div className={`${styles.col4}`} id="lmtDealType">
                      <ButtonToolbar>
                        <DropdownButton title={i18next.t(DealType)} id="dropdown-size-medium" className="trdDropDown btnText" style={this.props.selectedCssColorTheme.trdDropDown}>
                          {showPrice === "BOTH" || showPrice === "ASK" ?<MenuItem onClick={() =>this.selectDealType("BUY",1)} id="lmtOrdDealTyp1" className="dropDownList" style={this.props.selectedCssColorTheme.dropDownList}>{i18next.t("BUY")}</MenuItem> :null}
                          {showPrice === "BOTH" || showPrice === "BID" ?<MenuItem onClick={() =>this.selectDealType("SELL",0)} id="lmtOrdDealTyp2" className="dropDownList" style={this.props.selectedCssColorTheme.dropDownList}>{i18next.t("SELL")}</MenuItem> :null}
                          {showPrice === "BOTH" || showPrice === "ASK" ?<MenuItem onClick={() =>this.selectDealType("STOPBUY",1)} id="lmtOrdDealTyp3" className="dropDownList" style={this.props.selectedCssColorTheme.dropDownList}>{i18next.t("STOPBUY")}</MenuItem> :null}
                          {showPrice === "BOTH" || showPrice === "BID" ?<MenuItem onClick={() =>this.selectDealType("STOPSELL",0)} id="lmtOrdDealTyp4" className="dropDownList" style={this.props.selectedCssColorTheme.dropDownList}>{i18next.t("STOPSELL")}</MenuItem> :null}
                        </DropdownButton>
                      </ButtonToolbar>
                    </div>
                  :
                    <div className={`${styles.col4}`} id="lmtDealType">
                      <ButtonToolbar>
                        <DropdownButton title={i18next.t(DealType)} id="dropdown-size-medium" className="trdDropDown btnText" style={this.props.selectedCssColorTheme.trdDropDown}>
                          {showPrice === "BOTH" || showPrice === "ASK" ?<MenuItem onClick={() =>this.selectDealType("BUY",1)} id="lmtOrdDealTyp1" className="dropDownList" style={this.props.selectedCssColorTheme.dropDownList}>{i18next.t("BUY")}</MenuItem> :null}
                          {showPrice === "BOTH" || showPrice === "BID" ?<MenuItem onClick={() =>this.selectDealType("SELL",0)} id="lmtOrdDealTyp2" className="dropDownList" style={this.props.selectedCssColorTheme.dropDownList}>{i18next.t("SELL")}</MenuItem> :null}
                        </DropdownButton>
                      </ButtonToolbar>
                    </div>
                  }

                  <div className={`${styles.col4} ${styles.noPadding}`}>
                    <input type="text" autoComplete="off" className={`${styles.price} trdDropdownInput`} placeholder={i18next.t("price")} id="lmtOrdPrice" onBlur={this.onBlurPrice} value={Price} onChange={this.changePrice} onKeyPress={this.checkNumberValue} />
                  </div>

                  <div className={`${styles.col4} ${styles.validtyDiv}`} id="lmtValidty">
                    <ButtonToolbar>
                        <DropdownButton 
                            title={i18next.t(Validty)} 
                            id="dropdown-size-medium" 
                            className={`trdDropDown btnText ${this.props.userDetail.hasOwnProperty('isOnlyDayValForStopOrd') && this.props.userDetail.isOnlyDayValForStopOrd && this.state.OrderType === 3 ? 'hideCaret' : ''}`} 
                            style={this.props.selectedCssColorTheme.trdDropDown}
                            disabled={this.props.userDetail.hasOwnProperty('isOnlyDayValForStopOrd') && this.props.userDetail.isOnlyDayValForStopOrd && this.state.OrderType === 3}
                        >
                            {this.handleValidityTypes().map((item,index) => {
                                return (
                                    <MenuItem eventKey={item} onClick={() =>this.selectValidty(item.validityType)} id="lmtOrdGTC" className="dropDownList" style={this.props.selectedCssColorTheme.dropDownList}>{item.validityType}</MenuItem>
                                );
                            })}
                        </DropdownButton>
                    </ButtonToolbar>
                  </div>
                </div>

                {Validty === 'GTD' || Validty === 'GTT' ?
                  <div className={`${styles.rightPartLMT} rightPart ${styles.valRow}`}>
                    {Validty === 'GTD' || Validty === 'GTT' ?
                      <div className={Validty === 'GTT' ? `${styles.col6} ${styles.valDateRange}` : `${styles.col6} ${styles.valDateRangeGTD}`} id="validityDatePicker">
                        <div className="datepickerInputBox">
                          <DatePicker readOnly filterDate={isWeekday} selected={this.state.startDate} dateFormat="DD-MM-YYYY" onChange={this.handleChangeDate} ref="datepickerRef" className="datePickerIcon trdDropdownInput form-control" id="lmtOrdDatePicker" minDate={tradeDayEnd}/>
                        </div>
                      </div>
                    : null}

                    {Validty === 'GTT' ?
                      <div className={`${styles.col4} timeField`}>
                        <TimeField id="timeField" className={`${styles.valTimefield} form-control trdDropdownInput`} value={time} onChange={this.onTimeChange} onBlur={this.onBlurTime} />
                        <ButtonToolbar>
                          <DropdownButton title={this.state.timeFormat} className="input-w50 trdDropDown btnText" >
                            <MenuItem id="timeAM" onClick={() =>this.onSelectTimeFormat("AM")} className="dropDownList" >AM</MenuItem>
                            <MenuItem id="timePM" onClick={() =>this.onSelectTimeFormat("PM")} className="dropDownList" >PM</MenuItem>
                          </DropdownButton>
                        </ButtonToolbar>
                      </div>
                    : null}
                  </div>
                : null}

                <div className={`${styles.comments_wrap_overlay} commentDiv`}>
                  <div className={`${styles.comments}`}>
                    <textarea ref="comments" rows="1" placeholder={i18next.t("comments")} onBlur={this.onBlurLMTRmk} className={Validty === 'GTD' || Validty === 'GTT' ? `${styles.comment_textarea} form-control trdComments` : `${styles.commentsLmt} form-control trdComments`} id="cmntTextArea"></textarea>
                  </div>
                </div>
              </div>

              <div className={`${styles.button_wrap} col-sm-12`}>
                <div className="rightPart">
                  <div className={`${styles.col4}`}>&nbsp;</div>

                  <div className={`${styles.col4} ${styles.submitBtn} submitBtn`}>
                    <ButtonToolbar>
                      {DealType === 'BUY' || DealType === 'STOPBUY' ?
                        <Button className={disabledBtnOSP ? `lmtSubmit ${styles.button}  ${styles.disabled}` : `lmtSubmit ${styles.button}`}
                        onKeyPress={disabledBtnOSP ? this.onKeyPress : null} onClick={() => this.lmtOrderValidate(this.state.COM, selectedQuantityLmt, selectedMeasureLmt, Price, CmdtyAsk, ValueDate, DealType, this.state.dealTypeKey, OrderType,tradeDayEnd)} id="lmtOrdSubmitBtn">{i18next.t("submit")}</Button>
                      :
                        <Button className={disabledBtnOSP ? `lmtSubmit ${styles.button}  ${styles.disabled}` : `lmtSubmit ${styles.button}`}
                        onKeyPress={disabledBtnOSP ? this.onKeyPress : null} onClick={() => this.lmtOrderValidate(this.state.COM, selectedQuantityLmt, selectedMeasureLmt, Price, CmdtyBid, ValueDate, DealType, this.state.dealTypeKey, OrderType, tradeDayEnd)} id="lmtOrdSubmitBtn">{i18next.t("submit")}</Button>
                      }
                    </ButtonToolbar>
                  </div>

                  <div className={`${styles.col4} ${styles.clearBtn}`}>
                    <ButtonToolbar>
                      <Button className={`lmtClose ${styles.button}`} onClick={this.clearOrder} id="clearbtn">{i18next.t("close")}</Button>
                    </ButtonToolbar>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
			</div>
    );
  }
}
